export const BRANDING = {
  name: import.meta.env.VITE_APP_NAME || 'BiteOS',
  logoPath: 'branding/logo.png'
};